import { arxAbi } from '@/config/abi/arx.abi'
import { chain as appChain } from '@/config/chain'
import type { Address } from 'viem'
import { useReadContract } from 'wagmi'

export const useErc20BalanceOf = (
  erc20TokenAddress: Address,
  smartWalletAddress: Address | undefined,
  queryOverrides?: {
    staleTime?: number
    gcTime?: number
    refetchOnMount?: boolean | 'always'
  }
) => {
  return useReadContract({
    chainId: appChain.id,
    address: erc20TokenAddress,
    abi: arxAbi,
    functionName: 'balanceOf',
    args: smartWalletAddress ? [smartWalletAddress] : undefined,
    query: {
      enabled: !!erc20TokenAddress && !!smartWalletAddress,
      staleTime: 60 * 1000,
      gcTime: 60 * 60 * 24 * 1000,
      ...queryOverrides,
    },
  })
}
